exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".phone[data-v-80a3f3a4]{white-space:nowrap;font-size:13px;color:rgba(0,0,0,.85);vertical-align:middle;text-decoration:none}.phone span[data-v-80a3f3a4]{font-weight:700}.phone[data-v-80a3f3a4]:hover{text-decoration:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-80a3f3a4","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ext/Phone.vue
// module id = 1d0180aef2798be19555
// module chunks = 0